import React from "react";
import { CLOUD } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function CloudPage({ onNavigate }) {
  return (
    <ServicePage hero={CLOUD.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {CLOUD.platforms.map((p, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{p.name}</h4>
                <span className="capability-icon">{p.icon}</span>
              </div>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
